"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
const react_1 = __importStar(require("react"));
const redux_1 = require("redux");
const react_redux_1 = require("react-redux");
const UI_1 = require("~/components/UI");
const actions_1 = require("~/store/actions");
const ProjectItem_1 = require("~/components/ProjectManagement/ProjectsModal/ProjectItem");
const ContentListModalLoader_1 = require("~/components/UI/ContentModal/ContentListModalLoader");
const ProjectDetails_1 = require("~/components/ProjectManagement/ProjectsModal/ProjectDetails");
const assets_1 = require("~/assets");
const react_i18next_1 = require("react-i18next");
const accountTabs_1 = require("~/consts/accountTabs");
const routes_1 = require("~/consts/routes");
const useIntersectionObserver_1 = __importDefault(require("~/hooks/useIntersectionObserver"));
const useInfiniteFetch_1 = __importDefault(require("~/hooks/useInfiniteFetch"));
const useCurrentAccountTabId_1 = __importDefault(require("~/hooks/useCurrentAccountTabId"));
const react_router_dom_1 = require("react-router-dom");
const utils_1 = require("~/utils/utils");
const selectors_1 = require("~/store/user/selectors");
const react_helmet_async_1 = require("react-helmet-async");
const ProjectsModal_module_scss_1 = __importDefault(require("./ProjectsModal.module.scss"));
function ProjectsModal() {
    (0, useCurrentAccountTabId_1.default)(accountTabs_1.TAB_IDS.PROJECTS);
    const { t } = (0, react_i18next_1.useTranslation)('project');
    const loader = (0, react_1.useRef)(null);
    const intersectionObserver = (0, useIntersectionObserver_1.default)(loader);
    const currentUser = (0, react_redux_1.useSelector)(selectors_1.selectCurrentUser);
    const [selected, setSelected] = (0, react_1.useState)(null);
    const [projects, setProjects] = (0, react_1.useState)(null);
    const [searchIconVisible, setSearchIconVisible] = (0, react_1.useState)(true);
    const [filterActive, setFilterActive] = (0, react_1.useState)(false);
    const [page, setPage] = (0, react_1.useState)(0);
    const [field, setField] = (0, react_1.useState)('updatedAt');
    const [sort, setSort] = (0, react_1.useState)('DESC');
    const [forceRefresh, setForceRefresh] = (0, react_1.useState)(false);
    const [search, setSearch] = (0, react_1.useState)('');
    const { loading, result, setResult } = (0, useInfiniteFetch_1.default)({
        query: `${process.env.API_HOSTNAME}/api${routes_1.ROUTE_PROJECTS}`,
        page,
        field,
        sort,
        forceRefresh,
        search,
        limit: undefined,
    });
    const options = [
        { name: 'Project name' },
        { updatedAt: 'Last Modified' },
        { referenceNumber: 'Reference Number' },
        { status: 'Status' },
    ];
    const onKeyDownHandler = (event) => {
        if (event.key === 'Enter' || event.key === 'Accept' || event.key === ' ') {
            setFilterActive(!filterActive);
        }
    };
    const { dispatchDeleteProject, dispatchGetCurrentProject, dispatchDefaultBOM } = (0, redux_1.bindActionCreators)({
        dispatchDeleteProject: actions_1.deleteProject,
        dispatchGetCurrentProject: actions_1.getCurrentProject,
        dispatchDefaultBOM: actions_1.setDefaultBOM,
    }, (0, react_redux_1.useDispatch)());
    (0, react_1.useEffect)(() => setPage(0), [field, sort, search]);
    (0, react_1.useEffect)(() => {
        if (result) {
            if (page === 0) {
                setForceRefresh(false);
            }
            setSelected(result.length ? result[0] : null);
            setProjects(result);
        }
        else {
            setSelected(null);
            setProjects(loading ? null : []);
        }
    }, [result, loading]);
    (0, react_1.useEffect)(() => {
        if (intersectionObserver) {
            setPage((prev) => prev + 1);
        }
    }, [intersectionObserver]);
    const searchHandler = (0, utils_1.debounce)(500, (value) => setSearch(value));
    const deleteHandler = (projectId) => {
        dispatchDeleteProject(projectId);
        const projectsList = projects === null || projects === void 0 ? void 0 : projects.filter((project) => {
            return project.id !== projectId;
        });
        setProjects(projectsList || null);
        setResult(projectsList || null);
        setPage(0);
    };
    const duplicateHandler = () => {
        setForceRefresh(true);
        setPage(0);
    };
    const openProjectHandler = (param) => {
        dispatchDefaultBOM();
        dispatchGetCurrentProject(param);
    };
    const getMainContent = () => {
        if (!projects) {
            return undefined;
        }
        if (projects.length) {
            return (react_1.default.createElement("div", { className: ProjectsModal_module_scss_1.default.main, "data-scrollbar": projects.length > 6 },
                react_1.default.createElement("div", { className: ProjectsModal_module_scss_1.default['projects-container'] },
                    projects.map((project) => (react_1.default.createElement(ProjectItem_1.ProjectItem, { key: project.id, project: project, selected: project.id === (selected === null || selected === void 0 ? void 0 : selected.id), deletable: project.user_id === (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id) || (currentUser === null || currentUser === void 0 ? void 0 : currentUser.roleId) === 1, locked: Boolean(project.lockedById && project.lockedById !== (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id)), onSelect: setSelected, onDelete: deleteHandler, onOpen: openProjectHandler, onDuplicate: duplicateHandler }))),
                    projects.length > 19 ? react_1.default.createElement("div", { ref: loader }) : null)));
        }
        return (react_1.default.createElement("div", { className: ProjectsModal_module_scss_1.default['no-projects-container'] }, search ? (react_1.default.createElement("div", { className: ProjectsModal_module_scss_1.default['not-found'] },
            t('projects-modal.no-results-found-by'),
            " ",
            react_1.default.createElement("b", null, search))) : (react_1.default.createElement("div", { className: ProjectsModal_module_scss_1.default['no-projects'] },
            react_1.default.createElement("img", { src: assets_1.svgBasicHideIcon, alt: "" }),
            react_1.default.createElement("div", null, t('projects-modal.no-projects'))))));
    };
    const getSidebarContent = () => {
        if (!projects) {
            return react_1.default.createElement(ContentListModalLoader_1.ContentListModalSidebarLoader, null);
        }
        if (selected) {
            return react_1.default.createElement(ProjectDetails_1.ProjectDetails, { project: selected });
        }
        return react_1.default.createElement("div", { className: ProjectsModal_module_scss_1.default['no-selected'] }, t('projects-modal.no-project-selected'));
    };
    return (react_1.default.createElement(UI_1.ContentListModal, { headlineContent: react_1.default.createElement("div", { className: ProjectsModal_module_scss_1.default.header },
            react_1.default.createElement(react_helmet_async_1.Helmet, null,
                react_1.default.createElement("title", null, "My Projects | TBUILD")),
            react_1.default.createElement("div", { className: ProjectsModal_module_scss_1.default.title }, t('projects-modal.title')),
            react_1.default.createElement("div", { className: ProjectsModal_module_scss_1.default.controls },
                react_1.default.createElement(react_router_dom_1.Link, { to: routes_1.ROUTE_CREATE_PROJECT, className: ProjectsModal_module_scss_1.default['create-button'] },
                    react_1.default.createElement("img", { src: assets_1.svgBasicAddNew, alt: "" }),
                    " ",
                    t('create')),
                react_1.default.createElement("div", { className: ProjectsModal_module_scss_1.default['sorting-container'], "data-disabled": !(projects === null || projects === void 0 ? void 0 : projects.length) },
                    react_1.default.createElement(UI_1.ElementDropdown, { hideOnSelect: false, element: react_1.default.createElement("img", { src: assets_1.svgBasicSorting, className: ProjectsModal_module_scss_1.default['sorting-button'], "data-active": filterActive, "data-disabled": !(projects === null || projects === void 0 ? void 0 : projects.length), onClick: () => setFilterActive(!filterActive), onKeyDown: onKeyDownHandler, alt: "" }), placement: "bottom-end", dropdown: react_1.default.createElement(UI_1.SortingDropdown, { options: options, field: field, order: sort, setField: setField, setOrder: setSort, disabled: loading }), activeStateHandler: setFilterActive })),
                react_1.default.createElement("div", { className: ProjectsModal_module_scss_1.default.search, "data-empty": searchIconVisible, "data-disabled": !(projects === null || projects === void 0 ? void 0 : projects.length) && !search },
                    react_1.default.createElement(UI_1.Input, { type: "search", onInput: (value) => {
                            setSearchIconVisible(!value);
                            searchHandler(value);
                        }, placeholder: t('projects-modal.search-input') })))), mainContent: getMainContent(), sidebar: getSidebarContent() }));
}
exports.default = ProjectsModal;
